module.exports = __webpack_public_path__ + "img/orion-coloured-1.e26849d8.svg";